import { Box, Spinner, Text } from '@betterment/samba-react';

const LoadingState: React.FC = () => {
  return (
    <Box
      css={{
        alignItems: 'center',
        border: 'solid 1px #E5E5E5',
        borderRadius: 'medium',
        display: 'flex',
        flexDirection: 'column',
        marginTop: 'space.500',
        paddingBottom: 'space.800',
        paddingTop: 'space.800',
      }}
    >
      <Spinner variant="secondary" css={{ marginBottom: 'space.200' }} />
      <Text color="text.weak">Loading your documents...</Text>
    </Box>
  );
};

export default LoadingState;
